export default defineNuxtPlugin((nuxtApp) => {
	return {
		provide: { 
			slugify: (text) =>
    		text ? text
    		.toString()
    		.normalize('NFD')
    		.replace(/[\u0300-\u036f]/g, '')
    		.toLowerCase()
    		.trim()
    		.replace(/\s+/g, '-')
    		.replace(/[^\w-]+/g, '')
    		.replace(/--+/g, '-')
    		: ''    
		}
	};
})